import { Icon } from 'antd';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './index.less';

const cx = classNames.bind(styles);

const defaultProps = {
  disabled: true
};
const propTypes = {
  isActive: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  iconType: PropTypes.string.isRequired
};

const DataTypeIcon = ({ isActive, disabled, iconType }) => (
  <div
    className={`${cx('iconWrapper', {
      active: isActive,
      disabled
    })} mr-md mb-md`}
  >
    <Icon type={iconType} className={`${cx('icon')} icon-thinner`} />
  </div>
);

DataTypeIcon.defaultProps = defaultProps;
DataTypeIcon.propTypes = propTypes;
export default DataTypeIcon;



// WEBPACK FOOTER //
// ./src/views/DashboardSettings/components/DataTypeIcon.jsx